import React from "react";
import copy from "copy-to-clipboard";
import { toast } from "sonner";
import { Copy } from "lucide-react";
import { Button, Label, Tooltip } from "@/components/ui";
import { highlightHtmlSnippet } from "./highlightHtmlSnippet";

interface Props {
  label: string;
  snippet: string;
}

const EmbedSnippet: React.FC<Props> = ({ label, snippet }) => {
  const handleCopy = () => {
    if (!snippet) {
      toast.error("Embed URL is not available yet");
      return;
    }
    copy(snippet);
    toast.success("Iframe snippet copied");
  };

  return (
    <div className="min-w-0 border-t border-slate-200">
      <div className="flex items-center justify-between border-b border-slate-200 bg-slate-100 px-3 py-2">
        <Label className="text-slate-600">{label}</Label>
        <Tooltip>
          <Tooltip.Trigger
            render={
              <Button
                type="button"
                variant="ghost"
                size="icon"
                className="h-7 w-7 text-slate-500 hover:bg-slate-200 hover:text-slate-800"
                onClick={handleCopy}
                aria-label="Copy snippet"
              >
                <Copy className="h-3.5 w-3.5" />
              </Button>
            }
          />
          <Tooltip.Content>Copy snippet</Tooltip.Content>
        </Tooltip>
      </div>
      <pre className="m-0 overflow-x-auto whitespace-pre p-4 font-mono text-[14px] leading-6 selection:bg-slate-300/60">
        {highlightHtmlSnippet(snippet)}
      </pre>
    </div>
  );
};

const autoResizeSnippet = (src: string, height: number, iframeId: string, heightMessageType: string): string =>
  `<iframe id="${iframeId}" src="${src}" width="100%" height="${height}"></iframe>
<!-- Auto-resizes the iframe to match content height -->
<script>
  window.addEventListener("message", function (e) {
    if (e.data && e.data.type === "${heightMessageType}" && typeof e.data.height === "number") {
      var f = document.getElementById("${iframeId}");
      if (f) f.style.height = e.data.height + "px";
    }
  });
</script>`;

export { EmbedSnippet, autoResizeSnippet };
